export default __webpack_public_path__ + "static/media/focus-incorrect2.90c2d33b.PNG";